export default {
  title: 'Articole de top',
  columns: {
    name: 'Nume',
    quantity: 'Cantitate',
    amount: 'Sumă',
  },
};
